import { inject, Injector, runInInjectionContext } from "@angular/core";
import { FIREBASE_MESSAGING } from "@siat-fe/core";
import { getToken } from "firebase/messaging";
import { tapResponse } from "@ngrx/operators";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { from, pipe, switchMap, tap } from "rxjs";
import { RegisterDTO } from "../models";
import { AuthenticationService, UserProvider } from "../services";

type FirebaseState = {
    firebaseToken: string | null;
    isLoading: boolean;
    hasError: boolean;
};

const initialState: FirebaseState = {
    firebaseToken: null,
    isLoading: false,
    hasError: false
};

export const FirebaseStore = signalStore(
  { providedIn: 'root' },
  withState<FirebaseState>(initialState),
  withMethods((store,
    messaging = inject(FIREBASE_MESSAGING),
    injector = inject(Injector),
    userProvider = inject(UserProvider),
    authService = inject(AuthenticationService)
  ) => {
    const initFirebaseInternal = rxMethod<void>(
      pipe(
        tap(() => {
          patchState(store, { isLoading: true, hasError: false });
        }),
        switchMap(() => 
          from((async () => {
            const token = await runInInjectionContext(injector, () => getToken(messaging));
            return token;
          })()).pipe(
            tapResponse({
              next: (token) => {
                patchState(store, { firebaseToken: token, isLoading: false });
                userProvider.setFirebaseToken(token);
                if (!token) {
                  return;
                }
                // metodo per salvare il token a BE
                const requestRegister: RegisterDTO = {
                  tokenFirebase: token,
                  deviceType: 'web'
                }
                authService.registerFirebase(requestRegister)
                .subscribe({
                  next: () => null,
                  error: () => null,
                });
              },
              error: () => {
                patchState(store, { isLoading: false, hasError: true });
              },
            })
          )
        )
      )
    );

    return {
      initFirebase: () => {
        initFirebaseInternal();
      },
    };
  }),
)
